// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'dataviz-line-multi';

export const Component = () => (
  <g fill='none' stroke='currentColor' strokeLinecap='round' strokeLinejoin='round'>
    <path d='M.576.576v16.848h16.848M11.952 6.408l3.384-4.176M7.2 5.544l3.024 1.368M.576 8.424l4.68-2.808m6.408 6.768 3.528-1.944m-9 2.52h3.384m-9 2.232 3.528-1.728' />
    <path d='M5.04 5.04c0 .648.504 1.152 1.152 1.152s1.152-.504 1.152-1.152-.504-1.08-1.152-1.08-1.152.504-1.152 1.08zm5.112 2.304c0 .648.504 1.152 1.152 1.152s1.152-.504 1.152-1.152-.504-1.152-1.152-1.152-1.152.504-1.152 1.152zm5.04-5.688c0 .648.504 1.152 1.152 1.152s1.152-.504 1.152-1.152S16.992.504 16.344.504c-.648.072-1.152.576-1.152 1.152zm0 8.496c0 .648.504 1.152 1.152 1.152s1.152-.504 1.152-1.152S16.992 9 16.344 9s-1.152.504-1.152 1.152zM9.576 12.96c0 .648.504 1.152 1.152 1.152s1.152-.504 1.152-1.152-.504-1.152-1.152-1.152-1.152.504-1.152 1.152zm-5.616 0c0 .648.504 1.152 1.152 1.152s1.152-.504 1.152-1.152-.504-1.152-1.152-1.152-1.152.504-1.152 1.152z' />
  </g>
);

export const viewBox = '0 0 18 18';
